<template>
    <div class="app-row">
		<label :for="id" :class="{'focused' : this.focused || this.value}">{{label}}</label>
		<input 
            class="form-control"
            :class="{ 'invalid': error, 'valid': value }"
			:id="id"
			:name="name"
			:type="type"

            ref="input"
            @input="$emit('input', $event.target.value);"

			@focus="focusField"
			@blur="blurField"
            @change="validateChange"
		>
        <div v-if="error" class="help input-error">{{ errormsg || error }}</div>
        <ul class="value-selector mt-4" :class="{'show' : this.focused}">
			<li v-for="amount in amounts" 
                :data-value="amount.value" 
                :key="amount.value" 
                @click="selectAmount(amount.label)"
                class="active"
                >
                    {{amount.label}}
            </li>
		</ul>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: 'LoanSelect',
    $_veeValidate: {
        // value getter
        value() {
            return this.$el.value;
        },
        // name getter
        name() {
            return this.name;
        }
    },
	props: {
		label: String,
		id: String,
        name: String,
        errormsg: String,
		className: {
			type: String,
			default: 'form-control'
		},
		type: {
			type: String,
			default: 'text'
        },
        value: {
            type: null,
            default: null,
        },
        error: {
            type: String,
            default: null
        }
	},
	data(){
		return {
			focused: false,
			touched: false,
			valid: false,
            filled: false,
            amounts: []
		}
    },
    mounted() {
        // sync the input to the initial value
        this.$refs.input.value = this.value;
    },
	methods: {
		focusField(e){
			this.focused = true;
            this.touched = true;
            e.target.select();
		},
		blurField(e){
            if(e.target.value == ""){
                this.$refs.input.value = this.amounts[0].label;
                this.$emit('input', this.amounts[0].label);
            }
            setTimeout(function() {
                this.focused = false;
            }.bind(this), 150);
        },
        selectAmount(val){
            this.$refs.input.value = val;
            this.$emit('input', val);
        },

        validateChange(e){
            const amounts = this.amounts;
            const valid = this.amounts.map(el => el.label);
            const value = e.target.value;
            if(!isNaN(value)){
                if(value > amounts[amounts.length-1].max){
                    this.$refs.input.value = amounts[amounts.length-1].label;
                    this.$emit('input', amounts[amounts.length-1].label);
                } else if(value < amounts[0].min){
                    this.$refs.input.value = amounts[0].label;
                    this.$emit('input', amounts[0].label);
                } else {
	                const output = amounts.find(function(amount){
                        return value <= amount.max && value >= amount.min;
                    });
                    if(!output){
		                this.$refs.input.value = amounts[0].label;
                        this.$emit('input', amounts[0].label);
	                } else {
                        this.$refs.input.value = output.label;
                        this.$emit('input', output.label);
                    }
                }
            } else if(valid.includes(this.value)) {
		        
	        } else {
                this.$refs.input.value = amounts[0].label;
                this.$emit('input', amounts[0].label);
                
	        }
        }
    },
    computed: {
        ...mapGetters(["loanAmounts"]),
        allowedValues: function () {
            const allowed = this.amounts.map(el => el.label);
            return allowed;
        }
    },
    created(){
        let obj = this.loanAmounts.find(o => o.type === process.env.VUE_APP_SITE_TYPE);
        this.amounts = obj.amounts;
    }
}

</script>
